// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"fb5c64ab","51":"d2f283a3","178":"ab483de1","337":"eb916258","360":"2b50df85","513":"5f37b81a","743":"b253f84d"}[chunkId] + ".chunk.js";
};